// Formatting and color helpers for the App versions page and its chart.

import type { AdoptionBucket } from "../../services/appVersions";

const BUILD_COLORS = ["var(--build-1)", "var(--build-2)", "var(--build-3)", "var(--build-4)"];

// "Other builds" is neutral; builds run oldest → newest with the newest
// always on the brightest color, whatever the bucket count.
export function bucketColors(buckets: AdoptionBucket[]): string[] {
  const builds = buckets.filter((b) => b.key !== "other").length;
  let i = 0;
  return buckets.map((b) => {
    if (b.key === "other") return "var(--build-other)";
    const slot = BUILD_COLORS.length - builds + i++;
    return BUILD_COLORS[Math.max(0, slot)];
  });
}

export function formatCount(n: number): string {
  if (n >= 10_000) return `${Math.round(n / 1000)}k`;
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  return String(n);
}

export function formatShare(part: number, whole: number): string {
  if (!whole) return "—";
  const x = part / whole;
  return `${(x * 100).toFixed(x < 0.1 ? 1 : 0)}%`;
}

// A UTC day ("2026-10-17") as "Oct 17", the same calendar day in every timezone.
export function shortDay(day: string): string {
  const d = new Date(`${day}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return day;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });
}
